import { useEffect } from 'react';

import type { UtmSearch } from '@/schemas/utm';

import { persistProjectUtmAttribution } from '@/utils/project-utm-attribution';

/**
 * When the project URL includes any `?utm_*=` params, store them under a
 * project-keyed cookie so a later screener submission can be attributed to
 * the campaign — even for users who already have an account.
 */
export function usePersistProjectUtmFromSearch(
  projectId: string,
  search: UtmSearch | undefined,
): void {
  useEffect(() => {
    persistProjectUtmAttribution(projectId, search);
  }, [projectId, search]);
}
